const isBlank = function (value) {
  if (typeof value == 'undefined' || value == null || value == 0 || value == '') {
    return true;
  } else if (typeof value == 'string' && (value.length <= 0 || value.trim().length <= 0)) {
    return true;
  } else if (typeof value == 'object') {
    if (value.convalueuctor === [].convalueuctor && value.length <= 0) {
      return true;
    } else if (value.convalueuctor === {}.convalueuctor) {
      for (const key in value) {
        if (value.hasOwnProperty(key)) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export default isBlank;
